import { useQuery } from "@tanstack/react-query";
import { metricsApi } from "../api/metrics";
import { qk } from "../../lib/queryKeys";
import type {
  MetricsStatsParams,
  MetricsTrendsParams,
  MetricsDistributionParams,
  MetricsPatternsParams,
  MetricsComparisonParams,
} from "../api/types";

export const useMetricsStats = (params?: MetricsStatsParams) => {
  const metrics = params?.metrics;
  return useQuery({
    queryKey: qk.metrics.stats(params),
    queryFn: () => metricsApi.getStats(params),
    staleTime: 0, // Always fetch fresh data for real-time updates
    enabled: !!params?.user_ids?.length || !!params?.client_id, // Only fetch when users or client is selected
  });
};

export const useMetricsTrends = (params: MetricsTrendsParams) => {
  return useQuery({
    queryKey: qk.metrics.trends(params),
    queryFn: () => metricsApi.getTrends(params),
    staleTime: 0, // Always fetch fresh data for real-time updates
    enabled: !!params?.user_ids?.length || !!params?.client_id, // Only fetch when users or client is selected
  });
};

export const useMetricsDistribution = (params: MetricsDistributionParams) => {
  return useQuery({
    queryKey: qk.metrics.distribution(params.metric, params),
    queryFn: () => metricsApi.getDistribution(params),
    staleTime: 0, // Always fetch fresh data for real-time updates
    enabled: !!params?.user_ids?.length || !!params?.client_id, // Only fetch when users or client is selected
  });
};

export const useMetricsPatterns = (params: MetricsPatternsParams) => {
  return useQuery({
    queryKey: qk.metrics.patterns(params.metric, params),
    queryFn: () => metricsApi.getPatterns(params),
    staleTime: 5 * 60 * 1000,
  });
};

export const useMetricsComparison = (params: MetricsComparisonParams) => {
  return useQuery({
    queryKey: qk.metrics.comparison(params),
    queryFn: () => metricsApi.getComparison(params),
    staleTime: 5 * 60 * 1000,
  });
};
